<template>
    
  <BaseCardContentOnly :isLoading="[getCreditControlLoading]">
    
    <template #title>Products</template>

    <template #content>

      <v-row>
        <BaseLabelAndInfo>
          <template #label>Status</template>
          <template #value>{{getCreditControl.product_status | customPlaceholder}}</template>
        </BaseLabelAndInfo>
      </v-row>

      <v-row>
        <BaseLabelAndInfo>
          <template #label>VoIP</template>
          <template #value>{{getCreditControl.voip_status | customPlaceholder}}</template>
        </BaseLabelAndInfo>
      </v-row>

      <v-row>
        <BaseLabelAndInfo>
          <template #label>Telco</template>
          <template #value>{{getCreditControl.telco_status | customPlaceholder}}</template>
        </BaseLabelAndInfo>
      </v-row>

      <v-row>
        <BaseLabelAndInfo>
          <template #label>Web</template>
          <template #value>{{getCreditControl.web_status | customPlaceholder}}</template>
        </BaseLabelAndInfo>
      </v-row>

    </template>

  </BaseCardContentOnly>

</template>

<script>

  import { mapGetters } from 'vuex';

  export default {

    computed: {
      ...mapGetters('creditControl',['getCreditControl','getCreditControlLoading']),
    },

  }

</script>

<style lang="scss" scoped></style>
